import { useEffect, useRef, useState } from 'react';
import { stagesAPI } from '../../../api/stages';

/**
 * A symbol's Weinstein weekly stage (DWLF-382) for the chart band. Resets on a symbol change so the previous
 * symbol's band is never drawn on the new one; a failed fetch is reported, never turned into "no stage".
 */
export const useStage = ({ symbol, enabled = true }) => {
  const [stage, setStage] = useState(null);
  const [error, setError] = useState(null);
  const requestSeqRef = useRef(0);

  useEffect(() => {
    setStage(null);
  }, [symbol]);

  useEffect(() => {
    if (!enabled || !symbol) {
      setError(null);
      return undefined;
    }
    const seq = ++requestSeqRef.current;
    let cancelled = false;
    setError(null);
    stagesAPI.getStage(symbol)
      .then((data) => {
        if (cancelled || seq !== requestSeqRef.current) return;
        setStage(data ?? null);
      })
      .catch((err) => {
        if (cancelled || seq !== requestSeqRef.current) return;
        setError(err?.message || 'stage fetch failed');
        setStage(null);
      });
    return () => {
      cancelled = true;
    };
  }, [symbol, enabled]);

  return { stage, error };
};

export default useStage;
